module.exports = "<form #form=\"ngForm\">\r\n  <spk-card meta=\"Manage User Widgets\"  divider=\"true\">\r\n    <div class=\"row\">\r\n      <div class=\"col-md-4\" >\r\n        <div *ngFor=\"let widget of model;let i = index\">\r\n          <widget [model]=\"widget\" [showSelect]=\"true\"></widget>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </spk-card>\r\n</form>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/account/user-widget-selection/user-widget-selection.component.html
// module id = ./src/app/components/account/user-widget-selection/user-widget-selection.component.html
// module chunks = main